document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.catering-menu');
  if (!section) return;

  const tabs = section.querySelectorAll('.catering-menu__tab');
  const filters = section.querySelectorAll('.catering-menu__filter');
  const qtyButtons = section.querySelectorAll('.catering-qty__btn');
  const placeOrderBtn = section.querySelector('.catering-sidebar__button');

  let activeFilters = [];

  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault();

      const target = document.querySelector(tab.getAttribute('href'));
      if (!target) return;

      tabs.forEach((item) => item.classList.remove('is-active'));
      tab.classList.add('is-active');

      const offset = 180;
      const targetPosition =
        target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });

  filters.forEach((filter) => {
  filter.addEventListener('click', () => {
    const selected = filter.dataset.filter;

    if (activeFilters.includes(selected)) {
      activeFilters = activeFilters.filter(f => f !== selected);
      filter.classList.remove('is-active');
    } else {
      activeFilters.push(selected);
      filter.classList.add('is-active');
    }

    // Swap the icon
    const icon = filter.querySelector('.catering-menu__filter-dietary-icons');

    if (icon) {
      icon.src = filter.classList.contains('is-active')
        ? icon.dataset.active
        : icon.dataset.default;
    }

    applyFilters();
  });
});

  function applyFilters() {
    const cards = section.querySelectorAll('.catering-card');

    cards.forEach((card) => {
      const tags = card.dataset.tags || '';

      const matches =
        activeFilters.length === 0 ||
        activeFilters.every(filter => tags.includes(filter));

      card.classList.toggle('is-hidden', !matches);
    });

    section.querySelectorAll('.catering-menu__category').forEach((category) => {
      const hasVisibleCards = category.querySelector('.catering-card:not(.is-hidden)');
      category.style.display = hasVisibleCards ? '' : 'none';
    });
  }

  qtyButtons.forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const variantId = button.dataset.variantId;
      const action = button.dataset.action;

      const input = section.querySelector(
        `.catering-qty__input[data-variant-id="${variantId}"]`
      );

      if (!variantId || !input) return;

      let quantity = parseInt(input.value, 10) || 0;

      if (action === 'increase') quantity += 1;
      if (action === 'decrease') quantity = Math.max(0, quantity - 1);

      input.value = quantity;

      await updateCart(variantId, quantity);
      await refreshSidebar();

      if (action === "increase") {
  showToast();
}
    });
  });

  if (placeOrderBtn) {
    placeOrderBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = '/cart';
    });
  }

  async function updateCart(variantId, quantity) {
    const cart = await getCart();

    const existingItem = cart.items.find(
      (item) => String(item.variant_id) === String(variantId)
    );

    if (existingItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: existingItem.key,
          quantity: quantity
        })
      });
    } else if (quantity > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: quantity
        })
      });
    }
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    return response.json();
  }

  async function refreshSidebar() {
    const cart = await getCart();

    const itemsContainer = section.querySelector('.catering-sidebar__items');
    const emptyState = section.querySelector('.catering-sidebar__empty');
    const subtotal = section.querySelector('[data-cart-subtotal]');

    if (!itemsContainer || !emptyState || !subtotal) return;

    itemsContainer.innerHTML = '';

    section.querySelectorAll('.catering-qty__input').forEach((input) => {
      const item = cart.items.find(
        (cartItem) => String(cartItem.variant_id) === String(input.dataset.variantId)
      );

      input.value = item ? item.quantity : 0;
    });

    if (!cart.items || cart.items.length === 0) {
      emptyState.style.display = 'block';
    } else {
      emptyState.style.display = 'none';
    }

    cart.items.forEach((item) => {
      const itemEl = document.createElement('div');
      itemEl.className = 'catering-sidebar__item';

      itemEl.innerHTML = `
        <div class="catering-sidebar__item-title">
          ${item.product_title}
        </div>

        <div class="catering-sidebar__item-meta">
          ${item.variant_title || ''}
        </div>

        <div class="catering-sidebar__item-row">
          <div class="catering-sidebar__qty">
            <button type="button" data-sidebar-action="decrease" data-variant-id="${item.variant_id}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-sidebar-action="increase" data-variant-id="${item.variant_id}">+</button>
          </div>

          <span>${formatMoney(item.final_line_price)}</span>
        </div>

        <button type="button" data-remove-id="${item.variant_id}">
          Remove
        </button>
      `;

      itemsContainer.appendChild(itemEl);
    });

    subtotal.textContent = formatMoney(cart.total_price);
    subtotal.textContent = formatMoney(cart.total_price);

const warning = section.querySelector('.catering-sidebar__minimum-warning');
const button = section.querySelector('.catering-sidebar__button');
const backButtons = section.querySelectorAll('.catering-menu__back-button');

let hasItems = false;
let isValid = true;
let message = '';

  section.querySelectorAll('.catering-card').forEach(card => {

  let total = 0;

  card.querySelectorAll('.catering-qty__input').forEach(input => {
    total += parseInt(input.value, 10) || 0;
  });

  if (total > 0) {
    hasItems = true;
  }

  const warning = card.querySelector('.catering-card__warning');
  const totalDisplay = card.querySelector('.catering-card__total span');

if (totalDisplay) {
  totalDisplay.textContent = total;
}

  if (total === 0 || total >= 10) {

    if (warning) warning.style.display = 'none';

  } else {

    isValid = false;

    if (warning) {
      warning.style.display = 'block';
      warning.textContent = `Please select at least 10 sandwiches to continue (${total}/10 selected).`;
    }

    // const title = card.querySelector('.catering-card__title')?.textContent || 'This box lunch';
    // message += `${title}: must contain at least 10 sandwiches.<br>`;

    const title =
  card.querySelector('.catering-card__title')?.textContent.trim() || 'This boxed lunch';

const remaining = 10 - total;

message += `
  Please add an additional <strong>${remaining}</strong> more ${
    remaining === 1 ? 'sandwich' : 'sandwiches'
  } from <strong>${title}</strong> category.<br><br>
`;
  }

});

if (button && warning ) {

  if (!hasItems) {

    warning.style.display = 'none';
    warning.innerHTML = '';

    button.classList.add('is-disabled');
    backButtons.forEach(button => button.classList.remove('is-disabled'));

  } else if (!isValid) {

    warning.style.display = 'block';
    warning.innerHTML = message;

    button.classList.add('is-disabled');
    backButtons.forEach(button => button.classList.add('is-disabled'));

  } else {

    warning.style.display = 'none';
    warning.innerHTML = '';

    button.classList.remove('is-disabled');
    backButtons.forEach(button => button.classList.remove('is-disabled'));

  }

}

    section.querySelectorAll('[data-remove-id]').forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantId = button.dataset.removeId;

        await updateCart(variantId, 0);

        const input = section.querySelector(
          `.catering-qty__input[data-variant-id="${variantId}"]`
        );

        if (input) input.value = 0;

        await refreshSidebar();
      });
    });

    section.querySelectorAll('[data-sidebar-action]').forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantId = button.dataset.variantId;
        const action = button.dataset.sidebarAction;

        const item = cart.items.find(
          (cartItem) => String(cartItem.variant_id) === String(variantId)
        );

        if (!item) return;

        let quantity = item.quantity;

        if (action === 'increase') quantity += 1;
        if (action === 'decrease') quantity = Math.max(0, quantity - 1);

        await updateCart(variantId, quantity);
        await refreshSidebar();

        if (action === "increase") {
  showToast();
}
      });
    });
    const scrollbar = section.querySelector('.catering-sidebar__scrollbar');
const thumb = section.querySelector('.catering-sidebar__scroll-thumb');

if (scrollbar && thumb) {

    function updateScrollbar() {

        const visible = itemsContainer.clientHeight;
        const total = itemsContainer.scrollHeight;

        if (total <= visible) {
            scrollbar.style.display = "none";
            return;
        }

        scrollbar.style.display = "block";

        const thumbHeight = Math.max((visible / total) * visible, 40);
        thumb.style.height = thumbHeight + "px";

        const maxThumbMove = visible - thumbHeight;
        const maxScroll = total - visible;

        thumb.style.transform =
            `translateY(${(itemsContainer.scrollTop / maxScroll) * maxThumbMove}px)`;
    }

    updateScrollbar();

    itemsContainer.onscroll = updateScrollbar;

    window.addEventListener("resize", updateScrollbar);
}
  }

  function formatMoney(cents) {
    const currency =
      window.Shopify && Shopify.currency && Shopify.currency.active
        ? Shopify.currency.active
        : 'CAD';

    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  refreshSidebar();

  let toastTimer;

function showToast() {
  const toast = document.getElementById("catering-toast");
  if (!toast) return;

  toast.classList.add("is-visible");

  clearTimeout(toastTimer);

  toastTimer = setTimeout(() => {
    toast.classList.remove("is-visible");
  }, 3000);
}

const toast = document.getElementById("catering-toast");
const toastClose = toast?.querySelector(".catering-toast__close");

if (toastClose) {
  toastClose.addEventListener("click", () => {
    toast.classList.remove("is-visible");
    clearTimeout(toastTimer);
  });
}
});